type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_PRIORITY: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const MIN_LEVEL: LogLevel =
  import.meta.env.MODE === 'production' ? 'info' : 'debug';

export interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

export function createLogger(tag: string): Logger {
  const shouldLog = (level: LogLevel) =>
    LEVEL_PRIORITY[level] >= LEVEL_PRIORITY[MIN_LEVEL];

  return {
    debug: (...args: unknown[]) => {
      if (shouldLog('debug')) console.debug(`[${tag}]`, ...args);
    },
    info: (...args: unknown[]) => {
      if (shouldLog('info')) console.info(`[${tag}]`, ...args);
    },
    warn: (...args: unknown[]) => {
      if (shouldLog('warn')) console.warn(`[${tag}]`, ...args);
    },
    error: (...args: unknown[]) => {
      if (shouldLog('error')) console.error(`[${tag}]`, ...args);
    },
  };
}
